<template>
	<t-datepicker :value="value" :name="name" :weekStart="weekStart" />
</template>

<script>
export default {
	props: {
		value: {
			default: '',
		},
		name: {
			default: '',
		},
		weekStart: {
			default: 1,
		},
	},
};
</script>